export const checkEmptyString=(value?:string)=>{
    if(value===undefined || value==="" || value=== null){
        return ''
    }
    else return value;

}

export const postCommaString=(value?:string)=>{
    if(value===undefined || value==="" || value=== null){
        return ''
    }
    else return value+" ,";

}

export const preCommaString=(value?:string)=>{
    if(value===undefined || value==="" || value=== null){
        return ''
    }
    else return ", "+value;

}